// src/router/index.js

import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/HomePage.vue';
import WelcomePage from '../components/WelcomePage.vue';
import AboutPage from '../views/AboutPage.vue';
import { authGuard } from '@auth0/auth0-vue';

const routes = [
  {
    path: '/welcome',
    name: 'WelcomePage',
    component: WelcomePage,
  },
  {
    path: '/about',
    name: 'AboutPage',
    component: AboutPage,
    beforeEnter: authGuard, // Protect the About page
  },
  {
    path: '/',
    name: 'HomePage',
    component: Home,

  },
  {
    path: '/:site',
    name: 'HomePageDynamic',
    component: Home,
    props: (route) => ({ selectedSite: route.params.site }),
    beforeEnter: authGuard, // Protect dynamic site routes
  },
  {
    path: '/',
    redirect: '/welcome',
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// Add a global beforeEach hook for logging
router.beforeEach((to, from, next) => {
  next();
});

export default router;
